<div class="master-form">
    <div class="row justify-content-center align-items-center">
        <div class="col-sm-3 text-center">
            <div class="alert alert-danger fade show">
                <strong>{{'SECUSERLOGINTEXT' | translate}} - {{'Group' | translate}} -
                    {{'BRANCHNAME' | translate}}</strong>
            </div>
        </div>
        <div class="col-sm-9">
            <div class="row">
                <div class="col-11 alert alert-info alert-dismissible fade show">
                    <button type="button" class="close" data-dismiss="alert">&times;</button>
                    <strong>{{'NOTICE' |translate}}</strong> {{'PLACENOTICEDESC' | translate}}.
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <ul class="list-group">
                <li class="list-group-item px-1 text-center" (click)="SecLoginsClicked(secLogin)"
                    *ngFor="let secLogin of SecLogins" [ngClass]="{'active' : secLogin.status}">
                    {{ translate.currentLang =='ar'? secLogin.id+'-'+secLogin.groupNameAr+'-'+secLogin.branchNameAr:
                    secLogin.id+'-'+secLogin.groupNameEn+'-'+secLogin.branchNameEn}}
                </li>
            </ul>
        </div>
        <div class="container-fluid col-sm-9">
            <div class="row">
                <div class="col-11 text-center">
                    <ul class="btn-group list-group-horizontal row">
                        <li class="list-group-item col-3" (mouseup)="resourceTypeClicked(rooms)"
                            *ngFor="let rooms of roomsArray" [ngClass]="{'active' : rooms.active }">
                            {{ translate.currentLang =='ar'? rooms.code+'-'+rooms.nameAr:rooms.code+'-'+rooms.nameEn}}
                        </li>
                    </ul>
                    <br>
                    <hr>
                </div>
                <hr>
                <div *ngIf="showFilterTabs==true" class="col-12">
                    <tab-ctrl #tab [appCodes]="[6932,6934,6935]" [defaultTab]="defaultTab"
                        (clicked)="getlevelNumber($event)"></tab-ctrl>

                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-check">
                                <label>
                                    <input type="checkbox" id="all" (click)="toggleAll()" />
                                    <span for="all" [ngClass]="{'text-primary':allChecked}">
                                        {{'SELECTALL' | translate}}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngFor="let service of allDataByLevel;let i=index" class="form-check col-md-4 col-4">
                            <label [attr.for]="i">
                                <input type="checkbox" [id]="i" [(ngModel)]="service.selected"
                                    (click)="selectedResourceTypes(service)" />
                                <span>
                                    {{translate.currentLang == 'ar'? service.nameAr: service.nameEn}}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

                <div *ngIf="showFilterTabs==false" class="col-12">

                    <div class="form-check" *ngFor="let service of ResourceTypeArray;let i=index">
                        <label [attr.for]="i">
                            <input type="checkbox" [id]="i" [(ngModel)]="service.selected"
                                (click)="selectedResourceTypes(service)" />
                            <span>
                                {{translate.currentLang == 'ar'? service.nameAr: service.nameEn}}
                            </span>
                        </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <btns-ctrl [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
            </div>
        </div>
    </div>
</div>